import { render, staticRenderFns } from "./PublicBid.vue?vue&type=template&id=37eed314&scoped=true"
import script from "./PublicBid.vue?vue&type=script&lang=js"
export * from "./PublicBid.vue?vue&type=script&lang=js"
import style0 from "./PublicBid.vue?vue&type=style&index=0&id=37eed314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eed314",
  null
  
)

export default component.exports